<template>
    <div class="d-flex flex-column">
        <b class="d-block mb-2">Filter Tyre Sizes</b>
        <div class="d-flex align-items-center gap-3">
            <div class="mb-2 mb-sm-0" v-for="(option, key) in refinedOptions" :key="key">
                <Field :name="option.name" as="select" class="form-select size-input" v-model="this.$parent.selectedSizes[option.name]" @change="onSizeChange($event, option.name)">
                    <option value="">{{ option.label }}</option>
                    <template v-if="option.groups">
                        <optgroup v-if="option.groups.popular.length" label="Most Popular">
                            <option v-for="item in option.groups.popular" :key="'popular-' + item" :value="item">{{ item }}</option>
                        </optgroup>
                        <optgroup v-if="option.groups.rest.length" :label="option.groups.allLabel">
                            <option v-for="item in option.groups.rest" :key="'all-' + item" :value="item">{{ item }}</option>
                        </optgroup>
                    </template>
                    <template v-else>
                        <option v-for="item in option.data" :key="item" :value="item">{{ item }}</option>
                    </template>
                </Field>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';
    import mostPopularSizes from '@shared/mixins/mostPopularSizes';

    export default {
        props: ['formattedOptions', 'brandId', 'rangeId', 'homeDeliverySet', 'mostPopular', 'sizeOptions'],
        mixins: [mostPopularSizes],
        components: { Field },
        computed: {
            refinedOptions() {
                const selected = this.$parent?.selectedSizes ?? {};

                return (this.formattedOptions || []).map((option) => {
                    const groups = this.buildSizeGroups(option, selected);

                    if (!groups) {
                        return option;
                    }

                    return {
                        ...option,
                        data: [...groups.popular, ...groups.rest],
                        groups,
                    };
                });
            },
        },
        methods: {
            onSizeChange(event, name) {
                const selected = this.$parent?.selectedSizes;

                if (!selected) {
                    return;
                }

                if (event?.target?.tagName === 'SELECT') {
                    selected[name] = event.target.value;
                }

                this.clearInvalidSizeSelections(name, selected);
                this.$parent.filterTyres();
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
